import { __assign } from "tslib";
var parseHeaders = function (rawHeaders, data) {
    if (rawHeaders === void 0) { rawHeaders = {}; }
    if (data === void 0) { data = {}; }
    var forwardCookies = data.forwardCookies, forwardHeaders = data.forwardHeaders, isSSR = data.isSSR;
    var cookie = isSSR && (forwardCookies === null || forwardCookies === void 0 ? void 0 : forwardCookies.length)
        ? (rawHeaders.cookie || '')
            .split('; ')
            .filter(function (cookieStr) {
            var cookieName = cookieStr.split('=')[0];
            return forwardCookies.includes(cookieName);
        })
            .join('; ')
        : '';
    var headers = (forwardHeaders === null || forwardHeaders === void 0 ? void 0 : forwardHeaders.length)
        ? Object.entries(rawHeaders).reduce(function (acc, _a) {
            var _b;
            var key = _a[0], value = _a[1];
            return forwardHeaders.includes(key)
                ? __assign(__assign({}, acc), (_b = {}, _b[key] = value, _b)) : acc;
        }, {})
        : {};
    return __assign(__assign({}, headers), { cookie: cookie });
};
export default parseHeaders;
//# sourceMappingURL=parse-headers.js.map